export default __webpack_public_path__ + "static/media/Staminlogin.74fadaab.png";